import React from 'react';
import {
  IconSun,
  IconCloud,
  IconCloudRain,
  IconCloudSnow,
  IconWind,
  IconMoon,
  IconHome,
} from '@tabler/icons-react';

import type { WeatherIconType } from '~/domains/contest/domains/services/interfaces/player-pool-member.interface';

type IconWeatherProps = {
  weather: WeatherIconType;
  size?: number;
  color?: string;
  className?: string;
};

const weatherIconMap: Record<
  WeatherIconType,
  React.ComponentType<{ size?: number; color?: string; className?: string }>
> = {
  clear: IconSun,
  cloud: IconCloud,
  rain: IconCloudRain,
  snow: IconCloudSnow,
  wind: IconWind,
  night: IconMoon,
  indoor: IconHome,
  unknown: () => <span />,
};

export function IconWeather({ weather, size = 16, color, className }: IconWeatherProps) {
  const IconComponent = weatherIconMap[weather] || (() => <span />);

  return <IconComponent className={className} size={size} color={color} />;
}

IconWeather.displayName = 'IconWeather';

export default IconWeather;
